// src/components/Footer.js
import React from "react";
import "./css/Footer.css"; // Optional: external CSS

const Footer = () => {
  return (
    <footer className="footer">
      <span>Powered by</span>
      <img src="/stepswatch.png" alt="Stepswatch Logo" className="footer-logo" />
    </footer>
  );
};

export default Footer;
